import { appStore } from '@/store';
import { features, logger } from '@/lib';
import type { FormState } from '@/store/models/form/types';

/* === Begin Types === */
type CrsState = Pick<
  FormState,
  'crsLegalFirstName' | 'crsLegalLastName' | 'crsTaxDetails' | 'crsTaxStatus'
>;
/* === End Types === */

const getCrsState = (formState: FormState): CrsState => {
  const { crsLegalFirstName, crsLegalLastName, crsTaxStatus, crsTaxDetails } =
    formState;
  return {
    crsLegalFirstName,
    crsLegalLastName,
    crsTaxDetails,
    crsTaxStatus,
  };
};

const isEligibleForCRS = (): boolean => {
  const { form: formState } = appStore.getState();
  const { onboardOption } = formState;
  const isSignup = onboardOption.value === 'signup';

  return isSignup && features.isActive('shouldShowCRSInterstitial');
};

/**
 * @function shouldShowCRSInterstitial
 * @description validates if the onboard option is singup,
 * the CRS Treatment is active and that the user hasnt filled this already
 * @returns {Boolean} show or not the interstitial
 */
const shouldShowCRSInterstitial = (): boolean => {
  const { form: formState } = appStore.getState();
  const { bypassCRSInterstitial } = formState;
  if (isEligibleForCRS() && !bypassCRSInterstitial) {
    const logMessage = 'display_crs_interstitial';
    logger.info(logMessage);
    const { ui: uiActions } = appStore.getActions();
    uiActions.toggleIsCRSInterstitialOpen(true);
    return true;
  }

  return false;
};

export { getCrsState, isEligibleForCRS, shouldShowCRSInterstitial };
